import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

Hop.defineModule('forms.password-control', (root, param) => {
    const $root = $(root);

    const $passwordConfirm = $('#password_confirm');
    const $password = $('#password');

    function checkIsEqual() {
        if ($password.val() !== '' && $passwordConfirm.val() !== '' && $password.val() !== $passwordConfirm.val()) {
            return false;
        } else {
            return true;
        }
    }

    function displayError() {
        pushNotification(param.notEqualPass, {level: 'error'});
    }

    $root.find('button').click((e) => {
        if (!checkIsEqual()) {
            e.preventDefault();
            displayError();
        }
    });

    $root.on('keydown', (e) => {
        if (e.which === 13 && !checkIsEqual()) {
            e.preventDefault();
            displayError();
        }
    });
});
